import { HiOutlineMail } from 'react-icons/hi'
// import { TbBrandTelegram } from 'react-icons/tb'
import { FaWhatsapp } from 'react-icons/fa'

const data = [
  { id: 1, icon: <HiOutlineMail />, link: 'mailto:info.renovation@cartiltd.ca' },
  // {
  //   id: 2,
  //   icon: <TbBrandTelegram />,
  //   link: 'https://telegram.me/+13439878450',
  // },
  { id: 2, icon: <FaWhatsapp />, link: 'https://wa.me/+13439878450' },
]

export default data
